import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { TableEvent } from '@ngx-resource-toolkit/core';

@Component({
    selector: 'modal-confirmation',
    templateUrl: './modal-confirmation.component.html',
})
export class ModalConfirmationComponent {

    @ViewChild('modal') modal: any;

    @Input() message: string;
    @Input() event: TableEvent; // Utiliser plutôt buttonType, data et defaultAction
    @Input() loading: boolean;
    @Output() delete: EventEmitter<TableEvent> = new EventEmitter<TableEvent>(); // Utiliser plutôt buttonType, data et defaultAction
    @Input() buttonType: string = 'valide'; // 'delete'; // 'valide'
    @Output() defaultAction: EventEmitter<any> = new EventEmitter<any>();
    @Input() data: any;
    @Input() buttonLabel: string;

    constructor() {
    }

    handleClickDelete() {
        this.delete.emit(this.event);
    }
    handleClick() {
        console.log('modal-confirmation buttonType:', this.buttonType);
        const params = {
            buttonType: this.buttonType,
            data: this.data,
            event: this.event,
        };
        this.defaultAction.emit(params);
    }

    getButtonLabel() {
        if (this.buttonLabel) {
            return this.buttonLabel;
        }
        switch (this.buttonType) {
            case 'delete': return 'Supprimer';
            case 'cancel_invoice': return 'Annuler facture';
            case 'valide': return 'Valider';
        }
    }
}



// WEBPACK FOOTER //
// /home/debian/git/lea/lea-front/src/app/shared/miscellaneous/modal-confirmation.component.ts